import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { type Contact, type Paginated } from '@kontor/shared';
import { api } from '../../api';
import { useSession } from '../../session';
import './contacts.css';

/** Ansprechpartner einer Firma: die Personen, die ihr zugeordnet sind. Neue Personen legt man mit der Firma vorbelegt an. */
export function ContactPeople({ company }: { company: Contact }) {
  const { can } = useSession();
  const people = useQuery({
    queryKey: ['contacts', { companyId: company.id }],
    queryFn: () => api<Paginated<Contact>>('GET', `/contacts?companyId=${company.id}&perPage=100&sort=name`),
  });

  return (
    <section className="card">
      <div className="page-head">
        <h2>Ansprechpartner</h2>
        {can('contacts.write') && <Link className="btn btn--secondary btn--sm page-head__action" to={`/kontakte/neu?company=${company.id}`}>Ansprechpartner hinzufügen</Link>}
      </div>
      {people.isLoading && <p className="muted">Wird geladen …</p>}
      {people.isError && <p className="muted">Die Ansprechpartner konnten nicht geladen werden.</p>}
      {people.data?.data.length === 0 && <p className="muted">Noch kein Ansprechpartner. Eine Person ordnen Sie in ihrem eigenen Kontakt unter „Firma“ zu.</p>}
      {people.data && people.data.data.length > 0 && (
        <ul className="contact-inquiries">
          {people.data.data.map((p) => (
            <li key={p.id}>
              <Link to={`/kontakte/${p.id}`} className="strong-link">{p.name}</Link>
              <span className="muted small">{[p.email, p.phone].filter(Boolean).join(' · ')}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
